import { AssistResourceBM } from '@cue/api';

export const compareRooms = (a1: AssistResourceBM, a2: AssistResourceBM) => ('' + a1.name).localeCompare(a2.name);
